import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IExtendedSidebar, ISidebar } from '../../interfaces/sidebar';
import { HandleScreenService } from '../../services/handle-screen.service';

@Component({
  selector: 'ui-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Input() sidebarVoices: IExtendedSidebar[] | ISidebar[] = [];
  @Output() clickItemSidebar: EventEmitter<string> = new EventEmitter<string>();

  get isMobile(): boolean {
    return this.handleScreenService.isMobile();
  }

  constructor(private handleScreenService: HandleScreenService) {}

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.handleScreenService.updateScreenWidth();
  }

  voiceSelect(url: string): void {
    this.clickItemSidebar.emit(url);
  }
}
